import { StoreExt } from '@utils/reactExt'
import { observable, action } from 'mobx'
import { Schema$PopularSearchTerm, Schema$PopularSearchTermNews } from '@protocol/popularSearchTerm'
import _ from 'lodash'

export class PopularSearchTermStore extends StoreExt {

  @observable
  popularSearchTerms: Schema$PopularSearchTerm[]

  @observable
  popularSearchTermNews: Schema$PopularSearchTermNews[]

  popularSearchTermNewsHasMore: boolean

  isResetRollingIndex: boolean = false

  async fetchPopularSearchTerms(): Promise<void> {
    try {
      const result = await this.api.popularSearchTerm.fetchPopularSearchTerms(null)
      this.setPopularSearchTerms(result.items)
    } catch (err) {
      console.error(err)
    }
  }

  async fetchPopularSearchTermNews(params: { termId: number, reset?: boolean }): Promise<void> {
    const { termId, reset = false } = params
    if (reset) {
      this.setPopularSearchTermNews(null)
      this.setPopularSearchTermNewsHasMore(false)
    }

    try {
      const result = await this.api.popularSearchTerm.fetchPopularSearchTermNews({
        termId,
        offset: reset ? 0 : _.size(this.popularSearchTermNews),
      })

      this.setPopularSearchTermNews(_.concat(this.popularSearchTermNews || [], result.items))
      this.setPopularSearchTermNewsHasMore(result.hasMore)
    } catch (err) {
      console.error(err)
    }
  }

  @action
  setPopularSearchTerms(terms: Schema$PopularSearchTerm[]): void {
    this.popularSearchTerms = terms
  }

  @action
  setPopularSearchTermNews(news: Schema$PopularSearchTermNews[]): void {
    this.popularSearchTermNews = news
  }

  setPopularSearchTermNewsHasMore(hasMore: boolean): void {
    this.popularSearchTermNewsHasMore = hasMore
  }

  @action
  updatePopularSearchTerm(newTerm: Schema$PopularSearchTerm): void {
    const found = _.find(this.popularSearchTerms, term => term.id === newTerm.id)
    if (found) {
      found.term = newTerm.term
      found.xUrl = newTerm.xUrl
      found.youtubeUrl = newTerm.youtubeUrl
      found.order = newTerm.order
      found.rankBoardEnabled = newTerm.rankBoardEnabled
    } else {
      this.popularSearchTerms.push(newTerm)
    }

    this.setIsResetRollingIndex(true)
    this.setPopularSearchTerms(_.sortBy(this.popularSearchTerms, ['order']))
  }

  @action
  updatePopularSearchTermList(newTerms: Schema$PopularSearchTerm[]): void {
    _.forEach(newTerms, newTerm => {
      const found = _.find(this.popularSearchTerms, { id: newTerm.id })
      if (found) {
        found.term = newTerm.term
        found.xUrl = newTerm.xUrl
        found.youtubeUrl = newTerm.youtubeUrl
        found.order = newTerm.order
      } else {
        this.popularSearchTerms.push(newTerm)
      }
    })

    this.setIsResetRollingIndex(true)
    this.setPopularSearchTerms(_.sortBy(this.popularSearchTerms, ['order']))
  }

  deletePopularSearchTerm(id: number): void {
    const result = _.filter(this.popularSearchTerms, term => term.id !== id)
    this.setIsResetRollingIndex(true)
    this.setPopularSearchTerms(result)
  }

  deletePopularSearchTermList(termIds: number[]): void {
    const result = _.filter(this.popularSearchTerms, term => !_.includes(termIds, term.id))
    this.setIsResetRollingIndex(true)
    this.setPopularSearchTerms(result)
  }

  setIsResetRollingIndex(isReset: boolean): void {
    this.isResetRollingIndex = isReset
  }
}

export default new PopularSearchTermStore()
